import React from 'react';
import ReactDOM from 'react-dom';
// import { Auth0Provider } from '@auth0/auth0-react';
import './index.css';
import App from './App';


ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

{/* <Auth0Provider 
domain='andresgermain.us.auth0.com' 
clientId='dQ4iry2uxTrgrmALQ9LEwgS9FfjGZ2wV' 
redirectUri={window.location.origin}
>

</Auth0Provider> */}

